/**
 * @file
 * Attaches the behaviors for the Event component.
 */
!function ($, Drupal) {
  'use strict';

  Drupal.behaviors.events = {
    attach: function attach(context) {
      var currentURL = window.location.href;
      // Check if the current URL contains "/trainings-courses"
      if (currentURL.indexOf('/trainings-courses') !== -1) {
        // Add classes to specific elements on the "/trainings-courses" URL
        $('.event-teaser', context).addClass('mass-makes');
      }

    }
  };
}(jQuery, Drupal);
//# sourceMappingURL=events.js.map
